import React, { Component } from "react";

import api from "services/api";

class ReasonsModal extends Component {
  state = {
    reasons: [],
    loading: true,
    selected: null,
  };

  async componentDidMount() {
    try {
      const response = await api.get(
        "user/v2/document_request_reasons?per=100"
      );
      const { data } = response.data;

      this.setState({ reasons: data });
    } finally {
      this.setState({ loading: false });
    }
  }

  handleSelect = (id) => {
    const { selected } = this.state;
    const { onSelect } = this.props;

    this.setState({ selected: selected === id ? null : id });
    onSelect(selected === id ? null : id)
  };

  render() {
    const { reasons, selected } = this.state;

    return (
      <div className="document-reasons">
        {reasons.map((reason) => (
          <button
            className={`reason-checkbox ${
              selected === reason.id ? "selected" : ""
            }`}
            onClick={() => this.handleSelect(reason.id)}
          >
            <span>
              {selected === reason.id && (<i className="fa fa-check" />)}
            </span>
            {reason.attributes.title}
          </button>
        ))}
      </div>
    );
  }
}

export default ReasonsModal;

// import React, { Component } from 'react';

// import swal from 'sweetalert';

// import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
// import { Creators as ReasonsActions } from 'store/ducks/reasons';

// import { Form } from 'components';

// class Modal extends Component {
//   state = {
//     value: '',
//   };

//   componentDidMount() {
//     const { getReasonsRequest } = this.props;

//     getReasonsRequest();
//   }

//   componentDidUpdate(oldProps) {
//     const { reasons } = this.props;

//     if (oldProps.reasons.loading !== reasons.loading && reasons.data.length) {
//       this.setState({ value: reasons.data[0].id });
//     }
//   }

//   handleChangeReason = e => {
//     this.setState({ value: e.target.value });

//     swal.setActionValue(e.target.value);
//   };

//   render() {
//     const { value } = this.state;
//     const { reasons } = this.props;

//     return (
//       <Form className="page-form" onSubmit={() => {}}>
//         <Form.Field className="radio-field">
//           {!reasons.loading &&
//             reasons.data.map((reason, index) => (
//               <div className="row" key={String(reason.id)}>
//                 <Form.Input
//                   type="radio"
//                   name="reason"
//                   id="reason"
//                   value={reason.id}
//                   className="none-class col-md-1"
//                   onChange={this.handleChangeReason}
//                   checked={reason.id === value}
//                 />
//                 <Form.Label className="radio" key={String(reason.id)}>
//                   {reason.attributes.title}
//                 </Form.Label>
//               </div>
//             ))}
//         </Form.Field>
//       </Form>
//     );
//   }
// }

// const mapState = state => ({
//   reasons: state.reasons,
// });

// const mapActions = dispatch => bindActionCreators(ReasonsActions, dispatch);

// export default connect(
//   mapState,
//   mapActions,
// )(Modal);
